module.exports = __webpack_public_path__ + "img/marketing-icon.35a0cb59.jpg";